import { render, staticRenderFns } from "./idcardOcr.vue?vue&type=template&id=d95eecc4&scoped=true&"
import script from "./idcardOcr.vue?vue&type=script&lang=js&"
export * from "./idcardOcr.vue?vue&type=script&lang=js&"
import style0 from "./idcardOcr.vue?vue&type=style&index=0&id=d95eecc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95eecc4",
  null
  
)

export default component.exports